export const translations = {
  es: {
    hero: {
      badge: '¿Y Si Tu Hijo Ya Tuviera Talento?',
      title1: 'Tu hijo no nació solo para consumir contenido… ',
      title2: 'puede ser la voz detrás de él.',
      subtitle:
        'Aunque hoy no tengas experiencia ni idea de por dónde empezar, existe un camino real para que desarrolle su talento, crezca en una industria que la mayoría de los padres ni siquiera conoce… y sí, también genere ingresos.',
      highlight1: 'Hay niños que solo ven dibujos animados… ',
      highlight2: 'y otros que son la voz detrás de ellos.',
      highlight3: ' La diferencia no es talento. Es exposición.',
      cta: '👉 DESCUBRE CÓMO FUNCIONA ESTE MUNDO — Solo $14.97',
      check1: 'Sin experiencia previa',
      check2: 'Sin conexiones',
      check3: 'Desde casa',
      badge1Title: 'Expresión y Confianza',
      badge1Sub: 'Habilidades que lo acompañarán toda la vida',
      badge2Title: 'Una Industria Real',
      badge2Sub: 'donde su voz puede abrir puertas y oportunidades',
      productImage:
        'https://cdn.magicpatterns.com/uploads/2N93aH6DtPHLraiqeWq9eZ/Gemini_Generated_Image_y6xcg4y6xcg4y6xc.png',
      ctaLink:
        'https://voice-over-47.myshopify.com/products/doblaje-de-voz?variant=51349316305184',
    },
    problem: {
      title1: 'Un Mundo Que Existe… ',
      title2: 'Pero Casi Nadie Te Cuenta',
      card1Title: 'El Mundo Oculto',
      card1Desc:
        'Existe un mundo silencioso donde niños y jóvenes prestan su voz a personajes, películas y marcas. Un mundo donde no necesitas contactos, ni fama, ni experiencia previa. Solo algo que tu hijo ya tiene: su voz.',
      card2Title: 'Consumir vs. Crear',
      card2Desc:
        'Mientras otros niños pasan horas consumiendo contenido… algunos pocos están siendo pagados por crearlo. La diferencia no es talento. Es que alguien les abrió la puerta.',
      card3Title: 'Oportunidades Invisibles',
      card3Desc:
        'Como padre, quieres darle oportunidades. Pero si no sabes que existen… no puedes elegirlas. ¿Cuántas oportunidades pasan frente a ti sin que las veas?',
      alertTitle: 'Y aquí es donde cambia todo',
      alertDesc:
        'Porque esto no empieza con saber de doblaje. Empieza con una decisión simple: exponer a tu hijo a algo diferente. Algo que no solo entretiene… sino que construye habilidades reales.',
    },
    solution: {
      badge: '¡Edición 2026! Español',
      subtitle: 'No Necesitas Ser Experto',
      title1: 'Esto No Empieza Contigo…',
      title2: 'Empieza Con Una Decisión Simple',
      desc: 'Imagina esto por un momento… Tu hijo frente a un micrófono. Concentrado… divirtiéndose. Escuchas su voz transformarse. Y algo cambia. No solo en él… también en cómo lo ves. Confianza. Presencia. Una chispa que antes no estaba tan clara.',
      f1Title: 'Expresión',
      f1Desc:
        'Aprende a comunicar emociones con su voz — una habilidad que va más allá del doblaje.',
      f2Title: 'Seguridad',
      f2Desc:
        'Gana confianza al hablar frente a un micrófono y frente al mundo.',
      f3Title: 'Creatividad',
      f3Desc: 'Desarrolla su imaginación dando vida a personajes e historias.',
      f4Title: 'Oportunidades Reales',
      f4Desc:
        'Una industria que genera ingresos reales — y que crece cada año.',
      cta: 'Quiero Abrir Esa Puerta',
    },
    bonuses: {
      badge: 'Oferta Limitada',
      title1: '¡Regalos Exclusivos ',
      title2: 'Gratis Para Ti!',
      desc: 'Si ordenas hoy, te llevas estos 3 bonos de alto valor sin costo adicional — perfectos para que tú o tu hijo practiquen desde hoy.',
      free: 'GRATIS',
      b1Title: 'Bono #1 — Ejercicios de Dicción para Toda la Familia',
      b1Value: 'Valor: $29',
      b1Desc: 'Una rutina práctica para:',
      b1f1: 'Mejorar claridad al hablar',
      b1f2: 'Ejercicios divertidos para practicar solos o en familia',
      b1f3: 'Eliminar muletillas y ruidos',
      b1f4: 'Sonar profesional a cualquier edad',
      b1Footer: 'Solo 10–15 minutos al día. ¡Pueden hacerlo juntos!',
      b1Image:
        'https://cdn.magicpatterns.com/uploads/9y9V7JQCoRKJK5RMsZgCRx/Gemini_Generated_Image_k8zo6mk8zo6mk8zo.png',
      b2Title: 'Bono #2 — Cómo Crear Tu Demo Paso a Paso',
      b2Value: 'Valor: $37',
      b2Desc: 'Incluye ejemplos prácticos de:',
      b2f1: 'Demo comercial',
      b2f2: 'Demo para animación',
      b2f3: 'Ejemplos en español e inglés',
      b2Image:
        'https://cdn.magicpatterns.com/uploads/kVGHu1eQVQ87P5VaJ6xGEA/NZlb-uxoR_KJcca_EsXAJ.png',
      b2Footer:
        'Para que tú o tu hijo tengan un modelo a seguir. Sin adivinar.',
      b3Title: 'Bono #3 — Guiones Listos para Practicar (Español e Inglés)',
      b3Value: 'Valor: $19',
      b3Desc: 'Guiones listos para grabar de:',
      b3f1: 'Comerciales',
      b3f2: 'Animación',
      b3f3: 'Narración',
      b3Footer: 'Pueden empezar a practicar hoy mismo.',
      b3Image:
        'https://cdn.magicpatterns.com/uploads/1E28edUp6MykarNCvCerQL/Gemini_Generated_Image_tmsuijtmsuijtmsu.png',
    },
    testimonials: {
      title1: 'Lo Que Dicen ',
      title2: 'Otras',
      title3: ' Mamás Como Tú',
      desc: 'Padres reales que tomaron la decisión — y vieron el cambio en sus hijos.',
      t1Name: 'María G.',
      t1Role: 'Mamá de Actor de Voz Infantil',
      t1Text:
        'Mi hijo de 12 años grabó su primer comercial gracias a esta guía. ¡No lo podía creer! Ahora tiene audiciones cada semana.',
      t2Name: 'Laura P.',
      t2Role: 'Mamá y Actriz de Voz',
      t2Text:
        'Empecé pensando que era solo para mi hija, pero terminé haciéndolo yo también. ¡Ahora las dos hacemos doblaje juntas desde casa!',
      t3Name: 'Carmen S.',
      t3Role: 'Mamá Emprendedora',
      t3Text:
        'Con la urgencia económica que tenemos, esta guía fue una bendición. Por menos de $10 mi hijo ya está generando sus primeros ingresos con su voz.',
    },
    cta: {
      title: 'Imagina Unos Meses Adelante…',
      desc1:
        'Tu hijo ya entiende este mundo. Ya sabe cómo funciona. Tal vez ya ha hecho sus primeras prácticas. ',
      desc2: 'Tal vez incluso su primer ingreso.',
      desc3: ' Pero lo más importante… ',
      desc4: 'ya no está en el mismo lugar que otros niños.',
      desc5:
        ' Tiene una ventaja invisible. Una que crece con el tiempo. Y tú fuiste quien abrió esa puerta.',
      priceNormal: 'Precio Normal: $97',
      offer: 'Oferta por tiempo limitado',
      btn: '¡QUIERO ACCESO AHORA!',
      consultaBtn: '📞 Quiero una Consulta Online 1 a 1 por 30 min',
      consultaLink: '#consulta',
      f1Title: 'Garantía de 30 Días',
      f1Desc: 'En los primero 30 dias puedes descargarlo multiples veces.',
      f2Title: 'Pago Seguro',
      f2Desc: 'Tus datos están protegidos con encriptación SSL de 256-bits.',
      f3Title: 'Acceso Inmediato',
      f3Desc: 'Recibe tu acceso por email en menos de 2 minutos.',
      bundleImage:
        'https://cdn.magicpatterns.com/uploads/kitjHjgN5ZEyEbLufbTusc/Gemini_Generated_Image_fjnk73fjnk73fjnk.png',
    },
    footer: {
      desc: 'Ayudando a padres a descubrir el potencial de la voz de sus hijos.',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
      copyright:
        ' VozPro. Todos los derechos reservados. Este sitio no es parte de Facebook o Facebook Inc.',
      modalText:
        'Este es un texto de ejemplo para la sección legal. Aquí irían los detalles legales completos correspondientes a ',
      modalTerms: 'los términos de servicio',
      modalPrivacy: 'la política de privacidad',
      close: 'Cerrar',
    },
  },
  en: {
    hero: {
      badge: 'What If Your Child Already Had Talent?',
      title1: "Your child wasn't born just to consume content… ",
      title2: 'they can be the voice behind it.',
      subtitle:
        "Even if you have no experience or idea where to start, there is a real path for them to develop their talent, grow in an industry most parents don't even know exists… and yes, also earn income.",
      highlight1: 'Some kids just watch cartoons… ',
      highlight2: 'others are the voice behind them.',
      highlight3: " The difference isn't talent. It's exposure.",
      cta: '👉 DISCOVER HOW THIS WORLD WORKS — Only $14.97',
      check1: 'No prior experience',
      check2: 'No connections needed',
      check3: 'From home',
      badge1Title: 'Expression & Confidence',
      badge1Sub: 'Skills that will stay with them for life',
      badge2Title: 'A Real Industry',
      badge2Sub: 'where their voice can open doors and opportunities',
      productImage:
        'https://cdn.magicpatterns.com/uploads/613nRqFhaDwWz2XmnAUyLt/Gemini_Generated_Image_tjsj3ctjsj3ctjsj.png',
      ctaLink:
        'https://voice-over-47.myshopify.com/products/voice-over?variant=51351128998176',
    },
    problem: {
      title1: 'A World That Exists… ',
      title2: 'But Almost No One Tells You About',
      card1Title: 'The Hidden World',
      card1Desc:
        "There is a quiet world where kids and teens lend their voice to characters, movies, and brands. A world where you don't need connections, fame, or prior experience. Just something your child already has: their voice.",
      card2Title: 'Consuming vs. Creating',
      card2Desc:
        "While other kids spend hours consuming content… a select few are being paid to create it. The difference isn't talent. It's that someone opened the door for them.",
      card3Title: 'Invisible Opportunities',
      card3Desc:
        "As a parent, you want to give them opportunities. But if you don't know they exist… you can't choose them. How many opportunities pass right in front of you without you seeing them?",
      alertTitle: 'And this is where everything changes',
      alertDesc:
        "Because this doesn't start with knowing about dubbing. It starts with a simple decision: exposing your child to something different. Something that doesn't just entertain… but builds real skills.",
    },
    solution: {
      badge: '2026 Edition! Spanish',
      subtitle: "You Don't Need to Be an Expert",
      title1: "This Doesn't Start With You…",
      title2: 'It Starts With a Simple Decision',
      desc: "Imagine this for a moment… Your child in front of a microphone. Focused… having fun. You hear their voice transform. And something changes. Not just in them… but in how you see them. Confidence. Presence. A spark that wasn't so clear before.",
      f1Title: 'Expression',
      f1Desc:
        'Learn to communicate emotions with their voice — a skill that goes beyond dubbing.',
      f2Title: 'Confidence',
      f2Desc:
        'Gain confidence speaking in front of a microphone and in front of the world.',
      f3Title: 'Creativity',
      f3Desc:
        'Develop their imagination by bringing characters and stories to life.',
      f4Title: 'Real Opportunities',
      f4Desc: 'An industry that generates real income — and grows every year.',
      cta: 'I Want to Open That Door',
    },
    bonuses: {
      badge: 'Limited Offer',
      title1: 'Exclusive Gifts ',
      title2: 'Free For You!',
      desc: 'If you order today, you get these 3 high-value bonuses at no additional cost — perfect for you or your child to practice starting today.',
      free: 'FREE',
      b1Title: 'Bonus #1 — Diction Exercises for the Whole Family',
      b1Value: 'Value: $29',
      b1Desc: 'A practical routine to:',
      b1f1: 'Improve speaking clarity',
      b1f2: 'Fun exercises to practice alone or as a family',
      b1f3: 'Eliminate filler words and noises',
      b1f4: 'Sound professional at any age',
      b1Footer: 'Only 10–15 minutes a day. You can do it together!',
      b1Image:
        'https://cdn.magicpatterns.com/uploads/uQttF8P4N1nMhLDcDksUJo/Gemini_Generated_Image_czxniwczxniwczxn.png',
      b2Title: 'Bonus #2 — How to Create Your Professional Voice Demo',
      b2Value: 'Value: $37',
      b2Desc: 'Includes practical examples of:',
      b2f1: 'Commercial demo',
      b2f2: 'Animation demo',
      b2f3: 'Examples in Spanish and English',
      b2Image:
        'https://cdn.magicpatterns.com/uploads/kVGHu1eQVQ87P5VaJ6xGEA/NZlb-uxoR_KJcca_EsXAJ.png',
      b2Footer: 'So you or your child have a model to follow. No guessing.',
      b3Title: 'Bonus #3 — Ready-to-Practice Scripts (Spanish and English)',
      b3Value: 'Value: $19',
      b3Desc: 'Ready-to-record scripts for:',
      b3f1: 'Commercials',
      b3f2: 'Animation',
      b3f3: 'Narration',
      b3Footer: 'You can start practicing today.',
      b3Image:
        'https://cdn.magicpatterns.com/uploads/1E28edUp6MykarNCvCerQL/Gemini_Generated_Image_tmsuijtmsuijtmsu.png',
    },
    testimonials: {
      title1: 'What ',
      title2: 'Other',
      title3: ' Moms Like You Say',
      desc: 'Real parents who made the decision — and saw the change in their children.',
      t1Name: 'Maria G.',
      t1Role: 'Mom of Child Voice Actor',
      t1Text:
        "My 12-year-old son recorded his first commercial thanks to this guide. I couldn't believe it! Now he has auditions every week.",
      t2Name: 'Laura P.',
      t2Role: 'Mom and Voice Actress',
      t2Text:
        'I started thinking it was just for my daughter, but I ended up doing it too. Now we both do dubbing together from home!',
      t3Name: 'Carmen S.',
      t3Role: 'Entrepreneur Mom',
      t3Text:
        'With the financial urgency we have, this guide was a blessing. For less than $10 my son is already generating his first income with his voice.',
    },
    cta: {
      title: 'Imagine a Few Months From Now…',
      desc1:
        "Your child already understands this world. They know how it works. Maybe they've done their first practice sessions. ",
      desc2: 'Maybe even their first income.',
      desc3: ' But most importantly… ',
      desc4: "they're no longer in the same place as other kids.",
      desc5:
        ' They have an invisible advantage. One that grows over time. And you were the one who opened that door.',
      priceNormal: 'Regular Price: $97',
      offer: 'Limited time offer',
      btn: 'I WANT ACCESS NOW!',
      consultaBtn: '📞 I Want a 1-on-1 Online Consultation (30 min)',
      consultaLink: '#consulta',
      f1Title: '30-Day Guarantee',
      f1Desc: 'In the first 30 days you can download it multiple times.',
      f2Title: 'Secure Payment',
      f2Desc: 'Your data is protected with 256-bit SSL encryption.',
      f3Title: 'Immediate Access',
      f3Desc: 'Receive your access by email in less than 2 minutes.',
      bundleImage:
        'https://cdn.magicpatterns.com/uploads/q4VKSdMhX8ppxnRwCEcbT9/Gemini_Generated_Image_qho4h5qho4h5qho4.png',
    },
    footer: {
      desc: "Helping parents discover the potential of their children's voice.",
      terms: 'Terms and Conditions',
      privacy: 'Privacy Policy',
      copyright:
        ' VozPro. All rights reserved. This site is not part of Facebook or Facebook Inc.',
      modalText:
        'This is sample text for the legal section. Here would go the full legal details corresponding to ',
      modalTerms: 'the terms of service',
      modalPrivacy: 'the privacy policy',
      close: 'Close',
    },
  },
}

export type Language = 'es' | 'en'
export type TranslationKey = keyof typeof translations.es
